import { CanvasEventType } from '../constants/Constants';
import log from 'loglevel';
import { setObjectCanSelect } from '../utils/utils';

/**
 * 缩放代理
 *
 * @export
 * @class ZoomDelegate
 * @author zhenliang.sun
 */
export default class ZoomDelegate {
  /**
   * 缩放委托的模式
   * @param {*} c canvas结点
   * @param {*} opt
   * {
   *      maxZoom: 4
   *      minZoom: 1
   * }
   * @memberof ZoomDelegate
   */
  constructor(c, opt) {
    this.root = c;
    this.maxZoom = opt.maxZoom || 4;
    this.minZoom = opt.minZoom || 1;
  }

  set root(value) {
    this._root = value;
  }

  get root() {
    return this._root;
  }

  start() {
    this.root.on(CanvasEventType.MouseWheel, this._mouseWheelHandler.bind(this));
    this.root.on(CanvasEventType.MouseDown, this._mouseDownHandler.bind(this));
    this.root.on(CanvasEventType.MouseMove, this._mouseMoveHandler.bind(this));
    this.root.on(CanvasEventType.MouseUp, this._mouseUpHandler.bind(this));
    setObjectCanSelect(this.root, false);
  }

  stop() {
    this.root.off(CanvasEventType.MouseWheel, this._mouseWheelHandler);
    this.root.off(CanvasEventType.MouseDown, this._mouseDownHandler);
    this.root.off(CanvasEventType.MouseMove, this._mouseMoveHandler);
    this.root.off(CanvasEventType.MouseUp, this._mouseUpHandler);
    setObjectCanSelect(this.root, true);
  }

  _mouseWheelHandler(evt) {
    let delta = evt.e.deltaY / 1000;
    let pointer = this.root.getPointer(evt.e);
    let zoom = this.root.getZoom();
    zoom += delta;
    zoom = Math.min(Math.max(this.minZoom, zoom), this.maxZoom);
    this.root.zoomToPoint(
      {
        x: evt.e.offsetX,
        y: evt.e.offsetY
      },
      zoom
    );
    evt.e.preventDefault();
    evt.e.stopPropagation();

    log.info('zooom', zoom, evt.e.deltaY, this.root.getWidth(), this.root.getZoom());
  }

  _mouseDownHandler(evt) {
    let e = evt.e;
    if (e.altKey) {
      this.dragging = true;
      this.lastPosX = e.clientX;
      this.lastPosY = e.clientY;
    }
  }

  _mouseMoveHandler(evt) {
    if (!this.dragging) {
      return;
    }
    let e = evt.e;
    let trans = this.root.viewportTransform;
    trans[4] += e.clientX - this.lastPosX;
    trans[5] += e.clientY - this.lastPosY;

    // 左边界
    if (trans[4] >= 0) {
      trans[4] = 0;
    }
    // } else if (trans[4] + this.root.getWidth() < this.root.getWidth()) {
    //     trans = this.root.getWidth();
    // }

    // 上边界
    if (trans[5] > 0) {
      trans[5] = 0;
    }

    log.info(trans[4], trans[5]);

    this.root.requestRenderAll();
    this.lastPosX = e.clientX;
    this.lastPosY = e.clientY;
  }

  _mouseUpHandler(evt) {
    this.dragging = false;
  }
}
